// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__3LDgy","subtitle":"styles_subtitle__198aQ","containerService":"styles_containerService__iIrqw","noBorder":"styles_noBorder__v1Khv"};